import { IGDSStore } from './interfaces';
import * as actionTypes from './actionTypes';
import { convertTicketNum, getEarliestDate, getAllDatesInDetailData } from '@libs/core';

const initialState = {
    calendar: null,
    ticketNum: null,
    session: null,
    sessionPicked: null,
    totalAmount: '0',
    GDetail: null,
    GTempCalendarData: null,
    isGDSDetailLoading: false,
    GDSDetailFetchFail: false,
    isGDSSessionLoading: false,
    GDSSessionFetchFail: false,
    GNowList: null,
    GNowListData: null,
    GCalenderErr: '',
    GSessionErr: '',
    GTicketErr: '',
    Scrollto: null,
    submitWatcher: false,
    isSubmitSuccess: false,
};

const reducer = (state: IGDSStore = initialState, action: any) => {
    switch (action.type) {
        case actionTypes.SET_GRESTORE:
            return { ...initialState };
        case actionTypes.SET_GRESET:
            const { GNowListData, GTempCalendarData, GDetail } = state;
            const firstDay = getEarliestDate(getAllDatesInDetailData(GDetail, 'calendarDate')); // 因為EarliestBuyDay改固定，所以抓可選日期的第一天
            const returnState = {
                ...state,
                // calendar: dayjs(GNowListData.EarliestBuyDay).format('YYYY-MM-DD'),
                calendar: GNowListData.ExpectedUseDay? firstDay : null,
                GCalenderErr: '',
                GSessionErr: '',
                GTicketErr: '',
            };
            // 先確定有無月曆
            const ETItem = GNowListData.ExpectedUseDay && firstDay
                ? GTempCalendarData[firstDay]?.ETItem
                : GDetail.ETItem;

            // 再重設票種張數(場次重設會重打API時設定)
            Object.assign(returnState, { ticketNum: convertTicketNum(ETItem) });
            
            return returnState;
        case actionTypes.SET_GCALENDAR:
            return { ...state, calendar: action.payload };
        case actionTypes.SET_GTICKECTNUM:
            return { ...state, ticketNum: action.payload };
        case actionTypes.SET_GSESSION:
            return { ...state, session: action.payload };
        case actionTypes.SET_GSESSIONPICKED:
            return { ...state, sessionPicked: action.payload };
        case actionTypes.SET_GTOTALAMOUNT:
            return { ...state, totalAmount: action.payload };
        case actionTypes.SET_GDETAIL:
            return { ...state, GDetail: action.payload };
        case actionTypes.SET_GTEMPCALENDARDATA:
            return { ...state, GTempCalendarData: action.payload };
        case actionTypes.SET_ISGDSDETAILLOADING:
            return { ...state, isGDSDetailLoading: action.payload };
        case actionTypes.SET_GDSDETAILFETCHFAIL:
            return { ...state, GDSDetailFetchFail: action.payload };
        case actionTypes.SET_ISGDSSESSIONLOADING:
            return { ...state, isGDSSessionLoading: action.payload };
        case actionTypes.SET_GDSSESSIONFETCHFAIL:
            return { ...state, GDSSessionFetchFail: action.payload };
        case actionTypes.SET_GNOWLIST:
            return { ...state, GNowList: action.payload };
        case actionTypes.SET_GNOWLISTDATA:
            return { ...state, GNowListData: action.payload };
        case actionTypes.SET_GCALENDARERR:
            return { ...state, GCalenderErr: action.payload };
        case actionTypes.SET_GSESSIONERR:
            return { ...state, GSessionErr: action.payload };
        case actionTypes.SET_GTICKETERR:
            return { ...state, GTicketErr: action.payload };
        case actionTypes.SET_GSCROLLTO:
            return { ...state, Scrollto: action.payload };
        case actionTypes.SET_GSUBMITWATCHER:
            return { ...state, submitWatcher: action.payload };
        case actionTypes.SET_ISGSUBMITSUCCESS:
            return { ...state, isSubmitSuccess: action.payload };
        default:
            return state;
    }
};

export default reducer;
